import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import LoginPage from './components/Auth/LoginPage';
import DashboardLayout from './components/Layout/DashboardLayout';
import DashboardPage from './components/Dashboard/DashboardPage';
import LicitacionesPage from './components/Licitaciones/LicitacionesPage';
import LicitacionDetailPage from './components/Licitaciones/LicitacionDetailPage';
import DocumentosPage from './components/Documentos/DocumentosPage';
import UsuariosPage from './components/Usuarios/UsuariosPage';
import ConfigPage from './components/Configuracion/ConfigPage';
import TareasProgramadasPage from './components/TareasProgramadas/TareasProgramadasPage';
import MPLicitacionesPage from './components/MPLicitaciones/MPLicitacionesPage';
import ErrorBoundary from './components/Common/ErrorBoundary';

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  return user ? children : <Navigate to="/login" />;
}

function AdminRoute({ children }) {
  const { user } = useAuth();
  return user?.role === 'admin' ? children : <Navigate to="/dashboard" />;
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/" element={<ProtectedRoute><ErrorBoundary><DashboardLayout /></ErrorBoundary></ProtectedRoute>}>
              <Route index element={<Navigate to="/dashboard" />} />
              <Route path="dashboard" element={<DashboardPage />} />
              <Route path="licitaciones" element={<LicitacionesPage />} />
              <Route path="licitaciones/:codigo" element={<LicitacionDetailPage />} />
              <Route path="documentos" element={<DocumentosPage />} />
              <Route path="tareas-programadas" element={<TareasProgramadasPage />} />
              <Route path="mp-licitaciones" element={<MPLicitacionesPage />} />
              <Route path="usuarios" element={<AdminRoute><UsuariosPage /></AdminRoute>} />
              <Route path="configuracion" element={<ConfigPage />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
